// eslint-disable-next-line import/prefer-default-export
export const DATE_FORMAT = {
  DATE: 'MMM dd, yyyy',
  DATETIME: 'MMM dd, yyyy HH:mm (XXX)',
}
